import { render, staticRenderFns } from "./shopMemberdetailRouter.vue?vue&type=template&id=319016a6&scoped=true&"
import script from "./shopMemberdetailRouter.vue?vue&type=script&lang=js&"
export * from "./shopMemberdetailRouter.vue?vue&type=script&lang=js&"
import style0 from "./shopMemberdetailRouter.vue?vue&type=style&index=0&id=319016a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319016a6",
  null
  
)

export default component.exports